import React, { useEffect, useState } from 'react'
import { withStyles, Typography } from '@material-ui/core'
import styles from './styles'
import { Icon } from '@iconify/react'
import { useDispatch, useSelector } from 'react-redux'
import { componentBoxShowAction } from 'src/reducers/component-box/action'
import URLs from 'src/api/url'
import ComponentBoxContent from 'src/model/component-box'
import CertificateList from '../certificates-list'
import { patchCertificateAction } from 'src/reducers/certificate/action'
import { PatchContent, PatchData } from 'src/model/patch'
import { componentBoxHideAction } from 'src/reducers/component-box/action'
import SimpleHtmlTextEditor from 'src/components/simple-text-editor'
import { getCollectionLandingPageAction } from 'src/reducers/collection/action'
import CertificateBuilder from '@minicoursegenerator/certificate-builder'
import { CoreButton } from 'src/components/core'
import {
  messageBoxShowAction,
  messageBoxHideAction,
} from 'src/reducers/message-box/action'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import { useWorkspaceLogo } from 'src/utils/workspace-logo'
import { withPathVariable } from '../../path-variable'

const CertificateEdit = props => {
  const { classes } = props
  const dispatch = useDispatch()

  const collection = useSelector(state => state.collection.collection)
  const collectionSettings = useSelector(
    state => state.collection.landingPageSettings,
  )
  const certificateParent = useSelector(state => state.certificate)
  const certificate = certificateParent.certificate

  const [html, setHtml] = useState(
    certificate ? withPathVariable(certificate.html) : '',
  )

  const editHtmlValue = (html, blocks = null, background = null) => {
    setHtml(html)

    const patchSource = new PatchData(null, certificate.id)

    patchSource.addContent(
      new PatchContent(html, 'html', PatchData.OPERATION_ADD),
    )
    patchSource.addContent(
      new PatchContent(blocks, 'blocks', PatchData.OPERATION_ADD),
    )
    patchSource.addContent(
      new PatchContent(background, 'background', PatchData.OPERATION_ADD),
    )
    dispatch(patchCertificateAction(patchSource))
    dispatch(componentBoxHideAction())
  }

  const landingPageData = useSelector(
    state => state.collection.landingPageSettings,
  )
  // The path's own logo, else the workspace logo (as on issued certificates).
  const workspaceLogo = useWorkspaceLogo()
  useEffect(() => {
    if (!landingPageData) {
      return
    }
    const collectionLogo =
      landingPageData.logo || workspaceLogo || 'assets/gateway/empty-logo.png'

    const logo = URLs.CDN + collectionLogo

    const certificateLogo = document.getElementById('certificate-logo')
    if (certificateLogo) {
      certificateLogo.style.backgroundImage = 'url(' + logo + ')'
    }
  }, [landingPageData, workspaceLogo, html])

  const handleOpenCertificationList = () => {
    dispatch(
      componentBoxShowAction(
        new ComponentBoxContent(
          <CertificateList editHtmlValue={editHtmlValue} />,
          {
            hideCloseButton: true,
          },
        ),
      ),
    )
  }
  const handleCancel = () => {
    dispatch(messageBoxHideAction())
  }

  const handleSave = (html, blocks, background) => {
    dispatch(messageBoxHideAction())
    editHtmlValue(html, blocks, background)
  }

  const handleTemplateEdit = () => {
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          title: `<div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
            "
          >
            <Typography>Edit template</Typography>
          </div>`,
          buttons: [],
          component: (
            <CertificateBuilder
              initialBlock={withPathVariable(certificate.blocks)}
              initialBackground={certificate.background}
              saveHtml={handleSave}
              cancel={handleCancel}
            />
          ),
          callback: () => {},
        }),
      ),
    )
  }

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Typography className={classes.customizeText}>
          Customize Certificate
        </Typography>
        <div className={classes.templateButton}>
          <div className={classes.button} onClick={handleOpenCertificationList}>
            <Icon icon="tabler:refresh" fontSize={'16px'} />
            <Typography className={classes.buttonText}>
              Change Template
            </Typography>
          </div>
        </div>
      </div>
      {certificate && !certificate.blocks ? (
        <SimpleHtmlTextEditor
          className={classes.templateArea}
          html={html}
          onBlur={value => {
            editHtmlValue(value)
          }}
        />
      ) : (
        <div
          className={`${classes.templateArea} ${classes.certificatePreview}`}
        >
          <div dangerouslySetInnerHTML={{ __html: html }} />
          <div className={classes.certificateHoverButton}>
            <button
              className={classes.editCertificateButton}
              type="button"
              onClick={handleTemplateEdit}
            >
              <Icon icon="tabler:edit" fontSize={'16px'} />
              Edit template
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default withStyles(styles)(CertificateEdit)
